import {useState, useEffect, useRef, useCallback} from 'react'
import {Link , useParams , useNavigate, useLocation, useSearchParams} from 'react-router-dom'
import { Alert, Button, Dropdown, Spinner } from 'react-bootstrap'
import Abc from './Abc'
import BoostSettingsModal from './BoostSettingsModal'
import StarToggleButton from './StarToggleButton'
//import ReactTags from 'react-tag-autocomplete'
import BookMultiSelectorModal from  './BookMultiSelectorModal'
import TagsSelectorModal from './TagsSelectorModal'
import ShareTunebookModal from './ShareTunebookModal'
import TuneEnhanceButton from './TuneEnhanceButton'
import TuneFindSimilarButton from './TuneFindSimilarButton'
import {useSwipeable} from 'react-swipeable'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import YouTube from 'react-youtube';  
import LinksEditorModal from './LinksEditorModal'
import ViewModeSelectorModal from './ViewModeSelectorModal'
import TablatureSelector from './TablatureSelector'
import abcjs from "abcjs";
//import ParserProblemsDiff from './ParserProblemsDiff'
import useAbcjsParser from '../useAbcjsParser'
import useWindowSize from '../useWindowSize'
import TitleAndLyricsEditorModal from './TitleAndLyricsEditorModal'
import MediaPlayerMedia from '../components/MediaPlayerMedia'
import PDFViewer from './PDFViewer'
import ImagesManagerModal from './ImagesManagerModal'
import RecordingsManagerModal from './RecordingsManagerModal'  
import RepeatsEditorModal from './RepeatsEditorModal'  
import OpenSheetMusicDisplay from './OpenSheetMusicDisplay'
import useFileManager from '../useFileManager'
import FileRenderer from './FileRenderer'
import FileControls from './FileControls'
import TuneFilePanel from './TuneFilePanel'
import useGoogleDocument from '../useGoogleDocument'
import { findTuneFileMeta, isPdfTuneFileType } from '../tuneFiles'
import LyricsAutoscrollModal from './LyricsAutoscrollModal'
import TuneDownloadDropdown from './TuneDownloadMenu'
import { getTuneNotationFitMode, setNotationFitMode } from '../notationFitSettings'
import { NOTATION_FIT_VERTICAL, NOTATION_FIT_HORIZONTAL } from '../gigNotationFit'
import { prepareTuneViewNotationAbc } from '../notation/notationDisplayAbc'
import { buildUniqueChordsMap, isSectionMarkerChordName } from '../chordSheetUtils'
import { resolveTunesListPath } from '../searchFilterParams'
import { getSingleViewEditModes,
  editorPathForEditMode,
  viewModeToDisplayFlags,
  resolveDisplayFlagsForTune,
  defaultViewModeForTune,
  getAvailableDisplayFlags,
  showsMusicNotation,
} from '../viewModeUtils'
import { resolveTuneDisplayLayout, isViewModesEmpty, isStructureOnlyLayout } from '../tuneDisplayLayout'
import { clampGigZoom, getTuneGigZoom } from '../gigDisplaySettings'
import { setTuneDisplaySettings, applyTuneDisplaySettings } from '../tuneDisplaySettings'
import MarkdownContent from './MarkdownContent'
import StructureChordBlock from './StructureChordBlock'
import { buildTuneFooterMetaRows, hasTuneFooterMeta } from '../tuneAbcMetaDisplay'
import LyricsZoomControls from './LyricsZoomControls'
import FileZoomControls, { clampFileViewZoom } from './FileZoomControls'
import ChordPitchButton from './ChordPitchButton'
import TimedLyricsChordsView from './TimedLyricsChordsView'
import LyricsStructureSyncPanel from './LyricsStructureSyncPanel'
import { filterTuneVoices } from '../abcVoiceFilter'
import { getTuneVoiceKeys, getVisibleVoiceKeys } from '../abcVoiceViewSettings'
import { tuneHasExplicitChords, tuneHasLyricEmbeddedChords } from '../timedLyricsChordsDisplay'
import { shouldMusicSingleMountMediaEngine, shouldMusicSingleOwnMidiEngine } from '../nowPlayingQueuePlayback'
import { isQueueActive, getCurrentTuneId } from '../nowPlayingQueue'
import { shouldSyncViewedTuneToMediaController } from '../playbackNavigationUtils'
import { useCapoViewState } from '../useCapoViewState'
import { chordTransposeWithCapo } from '../capoViewUtils'
import StructureCapoControl from './StructureCapoControl'
import TuneTransposeControl from './TuneTransposeControl'
import { recordTuneView } from '../tuneViewHistoryStore'
import {buildSingleTuneTitle, DEFAULT_APP_TITLE, setDocumentTitle} from '../pageTitle'
import { tunePageSectionDomId } from '../searchListOrder'
import { isAddTuneAutoEnrichPending, subscribeAddTuneAutoEnrich, getAddTuneAutoEnrichState, dismissAddTuneAutoEnrichFailure, dismissAddTuneAutoEnrichChordPaste, dismissAddTuneAutoEnrichNotationPaste, dismissAddTuneAutoEnrichSummary, shouldSkipAbcMergeForChordPaste, abandonAutoEnrichNotationPaste, cancelAddTuneAutoEnrich } from '../addTuneAutoEnrich'
import useAutoEnrichOnOpen from '../useAutoEnrichOnOpen'
import { toast } from 'react-toastify'
import SearchProgressBar from './SearchProgressBar'
import PasteChordSheetModal from './PasteChordSheetModal'
import LockedSourcePasteModal from './LockedSourcePasteModal'
import { commitPasteChordSheetToTune } from '../commitPasteChordSheetToTune'
import useMediaResolverHealth from '../useMediaResolverHealth'
import useTuneSnapshotRouteSync, { applyTuneSnapshotFromSearchParams } from '../useTuneSnapshotRouteSync'
import { ensurePlainWordsFromNoteAlignedLyrics } from '../wLinesUtils'
import { isMobilePlatform } from '../platformUtils'
import useMusicToolbarWidth from '../useMusicToolbarWidth'
import usePublishedElementHeight from '../usePublishedElementHeight'
import usePinchZoomSteps from '../usePinchZoomSteps'
import {
  PINCH_TARGET_FILE,
  PINCH_TARGET_LYRICS,
  PINCH_TARGET_NOTATION_FIT,
  resolvePinchZoomTarget,
} from '../pinchZoomTarget'
import { isMusicToolbarCompact, isMusicToolbarFolded } from '../musicToolbarLayout'
import { getTune as getTuneFromRepository } from '../tuneRepository'
import ScratchpadWorkspacePickerModal from './scratchpad/ScratchpadWorkspacePickerModal'
import { exportTuneToScratchpadComposition } from '../exportTuneToScratchpadComposition'
import { scratchpadItemPath } from '../scratchpadExportToast'
import {
  buildMuseScoreSearchUrl,
  filterActionableNotationManualCandidates,
  isMuseScoreUrl,
} from '../chordSearchSites'
import { melodyHasMidBlockDoubleBarlines } from '../melodyBarlineNormalize'
import usePlayalongRecordSession from '../usePlayalongRecordSession'
import PlayalongRecordButton from './PlayalongRecordButton'
import PlayalongCompareOverlay from './PlayalongCompareOverlay'
import PlayalongStaffPitchStrips from './PlayalongStaffPitchStrips'
import PlayalongInlineRecordBar from './PlayalongInlineRecordBar'
import PlayalongRecordConfigModal from './PlayalongRecordConfigModal'
import PlayalongIncompleteTakeModal from './PlayalongIncompleteTakeModal'
import { shouldShowPlayalongRecordButton } from '../playalongTakes'
import { loadPlayalongSettings, savePlayalongSettings } from '../playalongSettings'
import {
  advanceBulkPlayalongSession,
  applyPlayalongTempoMultiplier,
  getBulkPlayalongSession,
  isBulkPlayalongCurrentTune,
} from '../bulkPlayalongSession'

function museScoreManualCandidates(manualCandidates) {
  return filterActionableNotationManualCandidates(manualCandidates).filter(function(item) {
    return isMuseScoreUrl(item.url)
  })
}

function truncateEnrichLabel(text, maxLen) {
  const value = String(text || '').trim()
  if (!value) return ''
  const limit = maxLen || 72
  if (value.length <= limit) return value
  return value.slice(0, limit - 1) + '…'
}

function MusicSingleSection(props) {
    let params = useParams();
    let navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const sectionTuneId = props.sectionTuneId != null && props.sectionTuneId !== ''
      ? props.sectionTuneId
      : params.tuneId
    const isActive = props.isActive !== false
    const pageStackMode = !!props.pageStackMode
    const pageSiblingIds = Array.isArray(props.pageSiblingIds) ? props.pageSiblingIds : null
    var windowSize = useWindowSize()
    const toolbarRef = useRef(null)
    const lastNotationChordRef = useRef('')
    const toolbarContainerWidth = useMusicToolbarWidth(toolbarRef)
    usePublishedElementHeight(toolbarRef, {
      varName: '--music-buttons-measured-height',
      host: function(node) { return node.parentElement },
    })
    const audioPlayer = useRef(); 
    const { available: resolverAvailable } = useMediaResolverHealth()
    
    //var youtubeProgressInterval = useRef()
    var speakTimeout = null
    const abcjsParser = useAbcjsParser({tunebook: props.tunebook})
    //var {searchYouTube} = useYouTubeSearch()
    const [showMedia, setShowMedia] = useState(false)

    useEffect(function() {
      if (isActive && sectionTuneId) recordTuneView(sectionTuneId)
    }, [isActive, sectionTuneId])

    const [mediaLinkNumber, setMediaLinkNumber] = useState(
      (isActive && params.mediaLinkNumber > 0) ? params.mediaLinkNumber : 0
    )
    const [mediaLoading, setMediaLoading] = useState(false)
    const [ytMediaPlayer, setYTMediaPlayer] = useState(null)
    const [mediaProgress, setMediaProgress] = useState(0)
    const [midiData, setMidiData] = useState(null)
    const [mediaRefresh, setMediaRefresh] = useState(new Date())
    const [isPlaying, setIsPlaying] = useState(false)
    const [autoStart, setAutoStart] = useState(false)
    const [hasSpoken, setHasSpoken] = useState(false)
    const [tune, setTune] = useState(null)
    const [tuneLoadState, setTuneLoadState] = useState('idle')
    const [notationFitMode, setNotationFitModeState] = useState(function() {
      return getTuneNotationFitMode(null)
    })
    const [lyricsZoom, setLyricsZoom] = useState(1.2)
    const [fileViewZoom, setFileViewZoom] = useState(1)
    const [voiceSettingsVersion, setVoiceSettingsVersion] = useState(0)
    const [autoEnrichPending, setAutoEnrichPending] = useState(function() {
      return isAddTuneAutoEnrichPending(sectionTuneId)
    })
    const [autoEnrichState, setAutoEnrichState] = useState(function() {
      return getAddTuneAutoEnrichState(sectionTuneId)
    })
    const [showAutoEnrichChordPaste, setShowAutoEnrichChordPaste] = useState(false)
    const [showAutoEnrichNotationPaste, setShowAutoEnrichNotationPaste] = useState(false)
    const autoEnrichSummaryShownRef = useRef('')
    const mediaControllerRef = useRef(props.mediaController)
    mediaControllerRef.current = props.mediaController
    const nowPlayingQueueRef = useRef(props.nowPlayingQueue)
    nowPlayingQueueRef.current = props.nowPlayingQueue
    const [pdfToolbarHost, setPdfToolbarHost] = useState(null)
    const [showScratchpadCopyPicker, setShowScratchpadCopyPicker] = useState(false)
    const [copyToScratchpadBusy, setCopyToScratchpadBusy] = useState(false)
    const [editMenuShow, setEditMenuShow] = useState(false)
    const [dismissMidBlockDoubleBarWarning, setDismissMidBlockDoubleBarWarning] = useState(false)

    useEffect(function() {
      setDismissMidBlockDoubleBarWarning(false)
    }, [sectionTuneId])

    useTuneSnapshotRouteSync(isActive ? tune : null, function(next) {
      setTune(next)
      props.tunebook.saveTune(next)
      if (props.forceRefresh) props.forceRefresh()
    })

    useEffect(function() {
        if (!isActive) return undefined
        setDocumentTitle(buildSingleTuneTitle(tune && tune.name))
        return function() {
            setDocumentTitle(DEFAULT_APP_TITLE)
        }
    }, [isActive, tune])

    useEffect(function() {
      function syncPending() {
        setAutoEnrichPending(isAddTuneAutoEnrichPending(sectionTuneId))
        setAutoEnrichState(getAddTuneAutoEnrichState(sectionTuneId))
      }
      syncPending()
      return subscribeAddTuneAutoEnrich(syncPending)
    }, [sectionTuneId])

    useEffect(function() {
      setShowAutoEnrichChordPaste(false)
      setShowAutoEnrichNotationPaste(false)
    }, [sectionTuneId])

    useEffect(function() {
      const summary = String(autoEnrichState.summary || '').trim()
      if (!summary || autoEnrichPending) return
      if (autoEnrichSummaryShownRef.current === summary) return
      autoEnrichSummaryShownRef.current = summary
      toast.info(summary, { autoClose: 12000 })
      dismissAddTuneAutoEnrichSummary(sectionTuneId)
    }, [autoEnrichPending, autoEnrichState.summary, sectionTuneId])

    useAutoEnrichOnOpen({
      enabled: isActive,
      tune: tune,
      tunebook: props.tunebook,
      abcjsParser: abcjsParser,
      accessToken: props.token && props.token.access_token ? props.token.access_token : '',
      resolverAvailable: resolverAvailable,
      searchIndex: props.searchIndex,
      loadTuneTexts: props.loadTuneTexts,
      forceRefresh: props.forceRefresh,
    })

    async function runCopyToScratchpad(workspaceId) {
        if (!tune || !workspaceId) return
        setCopyToScratchpadBusy(true)
        try {
            await exportTuneToScratchpadComposition({
                tune: tune,
                workspaceId: workspaceId,
                tunebook: props.tunebook,
                abcjsParser: abcjsParser,
                onOpenItem: function(itemId) {
                    navigate(scratchpadItemPath(itemId))
                },
            })
        } catch (e) {
            // export helper shows toast for errors
        } finally {
            setCopyToScratchpadBusy(false)
        }
    }

    function handleAutoEnrichNotationAbandoned() {
      if (!tune || !props.tunebook) {
        dismissAddTuneAutoEnrichNotationPaste(sectionTuneId)
        return
      }
      void abandonAutoEnrichNotationPaste({
        tuneId: sectionTuneId,
        tune: tune,
        tunebook: props.tunebook,
        accessToken: props.token || '',
        resolverAvailable: resolverAvailable,
        forceRefresh: props.forceRefresh,
      }).then(function(result) {
        setShowAutoEnrichNotationPaste(false)
        if (result && result.applied) {
          setTune(Object.assign({}, tune))
          if (typeof props.forceRefresh === 'function') props.forceRefresh()
          const label = result.source ? ('Notation from ' + result.source) : 'Notation applied'
          toast.info(label, { autoClose: 8000 })
        } else {
          dismissAddTuneAutoEnrichFailure(sectionTuneId)
        }
      })
    }
    
    var allowedImageMimeTypes = ['text/plain','image/*','application/pdf','application/musicxml','.musicxml','.mxl'] //application/musicxml
	var fileManager = useFileManager('files',props.token ? props.token : null, props.logout, tune, allowedImageMimeTypes, true)
	var allowedAudioMimeTypes = ['audio/*']
	var recordingsManager = useFileManager('recordings',props.token ? props.token : null, props.logout, tune, allowedAudioMimeTypes)
	var driveDocs = useGoogleDocument(props.token, props.logout || function() {})
	
	//const [files, setFiles] = useState([])
	//const [recordings, setRecordings] = useState([])

	//function forceFileRefresh(t) {
		//fileManager.search(null,t && t.id ? t.id : null,false).then(function(res) {
			//setFiles(res)
		//})
		//recordingsManager.search(null,t && t.id ? t.id : null,false).then(function(res) {
			//setRecordings(res)
		//})
	//}

    useEffect(function() {
        let cancelled = false
        const tuneId = sectionTuneId
        if (!tuneId) {
            setTune(null)
            setTuneLoadState('missing')
            return undefined
        }

        const fromProps = props.tunes ? props.tunes[new String(tuneId)] : null
        if (fromProps) {
            setTune(applyTuneSnapshotFromSearchParams(fromProps, isActive ? searchParams : { get: function() { return null } }))
            setTuneLoadState('ready')
            const mc = mediaControllerRef.current
            if (isActive && mc && mc.setTune
              && shouldSyncViewedTuneToMediaController(
                mc,
                nowPlayingQueueRef.current,
                fromProps.id
              )) {
              mc.setTune(fromProps)
            }
            return undefined
        }

        // Pre-hydrate book is empty; wait so we do not flash "could not be found".
        if (!props.tunesHydrated) {
            setTune(null)
            setTuneLoadState('loading')
            return undefined
        }

        setTune(null)
        setTuneLoadState('loading')
        getTuneFromRepository(tuneId).then(function(loaded) {
            if (cancelled) return
            if (loaded) {
                setupTuneView(loaded)
                setTune(applyTuneSnapshotFromSearchParams(loaded, isActive ? searchParams : { get: function() { return null } }))
                setTuneLoadState('ready')
                const mc = mediaControllerRef.current
                if (isActive && mc && mc.setTune
                  && shouldSyncViewedTuneToMediaController(
                    mc,
                    nowPlayingQueueRef.current,
                    loaded.id
                  )) {
                  mc.setTune(loaded)
                }
                return
            }
            setTune(null)
            setTuneLoadState('missing')
        }).catch(function() {
            if (cancelled) return
            setTune(null)
            setTuneLoadState('missing')
        })

        return function() {
            cancelled = true
        }
    },[sectionTuneId, props.tunes, props.tunesHydrated, props.mediaController && props.mediaController.playbackSpeed, searchParams, isActive])

    useEffect(function() {
        if (!isActive || !tune) return undefined
        const mc = mediaControllerRef.current
        if (mc && mc.setTune
          && shouldSyncViewedTuneToMediaController(
            mc,
            nowPlayingQueueRef.current,
            tune.id
          )) {
          mc.setTune(tune)
        }
        return undefined
    }, [isActive, tune && tune.id])

    useEffect(function() {
        if (!isActive) return undefined
        if (tuneLoadState !== 'missing') return undefined
        const mc = mediaControllerRef.current
        const queue = nowPlayingQueueRef.current
        if (!mc || !isQueueActive(queue) || queue.autoAdvance === false) return undefined
        const currentId = getCurrentTuneId(queue)
        if (!currentId || String(currentId) !== String(sectionTuneId)) return undefined
        if (typeof mc.reportPlaybackFailure === 'function') {
            mc.reportPlaybackFailure()
        }
    }, [isActive, tuneLoadState, sectionTuneId])
    
    //const [abc, setAbc] = useState('')
    //let tune = props.tunes ? props.tunes[new String(sectionTuneId)] : null
    const capoState = useCapoViewState(tune && tune.id, tune && tune.capo)
    const [playalongSettings, setPlayalongSettings] = useState(function() {
      return loadPlayalongSettings()
    })
    const bulkPlayalongAutoStartRef = useRef('')

    const handleBulkPlayalongSessionComplete = useCallback(function() {
      if (!tune || !tune.id || !isBulkPlayalongCurrentTune(tune.id)) return
      const result = advanceBulkPlayalongSession()
      if (result.done) {
        toast.success(
          'Play along complete — recorded ' + (result.completed || 0) + ' tune' +
          (result.completed === 1 ? '' : 's') + '.'
        )
        return
      }
      const nextTune = props.tunes && props.tunes[result.nextTuneId]
      const name = nextTune && nextTune.name ? nextTune.name : 'next tune'
      toast.info(
        'Play along ' + result.progress.current + '/' + result.progress.total + ': ' + name
      )
      navigate('/tunes/' + encodeURIComponent(result.nextTuneId))
    }, [tune, props.tunes, navigate])

    const playalong = usePlayalongRecordSession({
      tune: tune,
      tunebook: props.tunebook,
      mediaController: props.mediaController,
      viewMode: props.viewMode,
      setViewMode: props.setViewMode,
      setTune: setTune,
      playbackGain: playalongSettings.playbackGain,
      onSessionComplete: handleBulkPlayalongSessionComplete,
    })

    const [playalongTempoDialogOpen, setPlayalongTempoDialogOpen] = useState(false)
    const [playalongTempoBpm, setPlayalongTempoBpm] = useState(120)
    const [showPlayalongPianoRoll, setShowPlayalongPianoRoll] = useState(true)
    const [hiddenPlayalongTakeIds, setHiddenPlayalongTakeIds] = useState({})

    function updatePlayalongSettings(next) {
      const saved = savePlayalongSettings(next)
      setPlayalongSettings(saved)
      return saved
    }

    function togglePlayalongTakeHidden(recordingId) {
      const id = recordingId != null ? String(recordingId) : ''
      if (!id) return
      setHiddenPlayalongTakeIds(function(prev) {
        const next = Object.assign({}, prev)
        if (next[id]) delete next[id]
        else next[id] = true
        return next
      })
    }

    useEffect(function() {
      if (!playalong.isRecording || playalongTempoDialogOpen) return undefined
      function onKeyDown(e) {
        if (e.code !== 'Space' && e.key !== ' ') return
        if (e.metaKey || e.ctrlKey || e.altKey) return
        const target = e.target
        if (target) {
          const tag = String(target.tagName || '').toLowerCase()
          if (tag === 'input' || tag === 'textarea' || tag === 'select') return
          if (target.isContentEditable) return
        }
        e.preventDefault()
        if (playalong.stop) playalong.stop('click')
      }
      window.addEventListener('keydown', onKeyDown)
      return function() {
        window.removeEventListener('keydown', onKeyDown)
      }
    }, [playalong.isRecording, playalongTempoDialogOpen, playalong.stop])

    useEffect(function() {
      const ids = {}
      ;(playalong.takes || []).forEach(function(take) {
        if (take && take.recordingId) ids[String(take.recordingId)] = true
      })
      setHiddenPlayalongTakeIds(function(prev) {
        let changed = false
        const next = {}
        Object.keys(prev || {}).forEach(function(id) {
          if (ids[id]) next[id] = true
          else changed = true
        })
        return changed ? next : prev
      })
    }, [(playalong.takes || []).map(function(take) { return take.recordingId }).join(',')])

    useEffect(function() {
      if (!tune || !props.tunebook || !props.tunebook.abcTools
        || typeof props.tunebook.abcTools.getTempo !== 'function') return
      const bpm = parseFloat(props.tunebook.abcTools.getTempo(tune))
      setPlayalongTempoBpm(Number.isFinite(bpm) && bpm > 0 ? bpm : 120)
    }, [tune && tune.id, props.tunebook])

    useEffect(function() {
      bulkPlayalongAutoStartRef.current = ''
    }, [tune && tune.id])

    useEffect(function() {
      if (!tune || !tune.id) return undefined
      const session = getBulkPlayalongSession()
      if (!session || !isBulkPlayalongCurrentTune(tune.id)) return undefined

      const startKey = String(tune.id) + ':' + String(session.startedAt || '')
      if (bulkPlayalongAutoStartRef.current === startKey) return undefined

      const fileOverlayActive = !!findTuneFileMeta(tune, tune.activeFile)
      if (!shouldShowPlayalongRecordButton(tune, props.tunebook, fileOverlayActive)) {
        bulkPlayalongAutoStartRef.current = startKey
        handleBulkPlayalongSessionComplete()
        return undefined
      }

      bulkPlayalongAutoStartRef.current = startKey
      setShowPlayalongPianoRoll(true)
      if (playalong.openCompare) playalong.openCompare()

      const tempo = applyPlayalongTempoMultiplier(
        playalongTempoBpm,
        session.tempoMultiplier
      )
      const settings = session.settings || playalongSettings

      const timer = window.setTimeout(function() {
        if (playalong.start && !playalong.isRecording) {
          playalong.start(tempo, settings)
        }
      }, 400)
      return function() {
        window.clearTimeout(timer)
      }
    }, [
      tune,
      tune && tune.id,
      props.tunebook,
      playalongSettings,
      playalongTempoBpm,
      playalong.openCompare,
      playalong.start,
      playalong.isRecording,
      handleBulkPlayalongSessionComplete,
    ])
    
    //let abc = '' //props.tunebook.abcTools.settingFromTune(tune).abc
    const handlers = useSwipeable({
        delta:300,
        trackMouse: false,    
      onSwipedRight: (eventData) => {
          props.tunebook.navigateToPreviousSong(tune.id, navigate, location.pathname, {
            forceSearchList: true,
          })
      },
      onSwipedLeft: (eventData) => {
          props.tunebook.navigateToNextSong(tune.id, null, navigate, location.pathname, {
            forceSearchList: true,
          })
      }
    });  
    const swipeRef = handlers.ref
    const [sectionRootEl, setSectionRootEl] = useState(null)
    const setSectionRoot = useCallback(function(el) {
      setSectionRootEl(el)
      swipeRef(el)
    }, [swipeRef])

    // Refreshed every render with the current view so pinch steps hit the right zoom.
    const pinchRouteRef = useRef(null)
    const pinchSessionRef = useRef({ lyricsZoom: null, fitApplied: false })
    usePinchZoomSteps({
      target: sectionRootEl,
      isEligibleTarget: function(target) {
        return !(target && target.closest && target.closest('.music-buttons, .modal'))
      },
      onStep: function(direction) {
        const route = pinchRouteRef.current
        if (!route) return
        const session = pinchSessionRef.current
        if (route.target === PINCH_TARGET_FILE) {
          setFileViewZoom(function(z) { return clampFileViewZoom(z + 0.1 * direction) })
        } else if (route.target === PINCH_TARGET_LYRICS) {
          if (route.fitHeightOn && !session.fitApplied) {
            // Fit-height sizes lyrics itself; only pinching out leaves it.
            if (direction < 0) return
            route.setNotationFit(NOTATION_FIT_HORIZONTAL)
            session.fitApplied = true
          }
          const base = session.lyricsZoom != null ? session.lyricsZoom : route.lyricsZoom
          const next = clampGigZoom(base + 0.1 * direction)
          session.lyricsZoom = next
          setLyricsZoom(next)
        } else if (route.target === PINCH_TARGET_NOTATION_FIT) {
          if (session.fitApplied) return
          session.fitApplied = true
          const mode = direction < 0 ? NOTATION_FIT_VERTICAL : NOTATION_FIT_HORIZONTAL
          if (mode !== route.notationFitMode) route.setNotationFit(mode)
        }
      },
      onEnd: function() {
        const route = pinchRouteRef.current
        const session = pinchSessionRef.current
        if (route && session.lyricsZoom != null) route.persistLyricsZoom(session.lyricsZoom)
        pinchSessionRef.current = { lyricsZoom: null, fitApplied: false }
      },
    })
    
    
    
    //useEffect(function() {
        //if (!showMedia) {
            //clearInterval(youtubeProgressInterval.current)
            //youtubeProgressInterval.current = null
        //}
    //}, [showMedia])
    
    function getBeatsPerBar(meter) {
          switch (meter) {
            case '2/2':
              return 2
            case '3/2':
              return 3
            case '4/2':
              return 4
            case '3/8':
              return 1
            case '6/8':
              return 2
            case '9/8':
              return 3
            case '12/8':
              return 4
            case '2/4':
              return 2
            case '3/4':
              return 3
            case '4/4':
              return 4
            case '6/4':
              return 2
            case '9/4':
              return 3
          }
          return 4
        
    }
    

    function setupTune() {
        setupTuneView(props.tunes ? props.tunes[sectionTuneId] : null)
    }

    function setupTuneView(tune) {
        if (tune) {
           applyTuneDisplaySettings(tune)
           setFileViewZoom(1)
           if (tune.viewMode) {
               setNotationFitModeState(getTuneNotationFitMode(tune))
               if (isActive) props.setViewMode(tune.viewMode)
           } else {
               const hasChordsForDefault = tuneHasExplicitChords(tune, props.tunebook, abcjsParser)
               const defaultMode = defaultViewModeForTune(tune, props.tunebook, {
                   hasChords: hasChordsForDefault,
                   hasLyricInlineChords: tuneHasLyricEmbeddedChords(tune),
               })
               // Defaulted-to-notation tunes should also default to fit-height.
               if (tune.notationFit !== NOTATION_FIT_VERTICAL && tune.notationFit !== NOTATION_FIT_HORIZONTAL && showsMusicNotation(defaultMode)) {
                   setNotationFitModeState(NOTATION_FIT_VERTICAL)
               } else {
                   setNotationFitModeState(getTuneNotationFitMode(tune))
               }
               if (isActive) props.setViewMode(defaultMode)
           }
           //props.tunebook.utils.scrollTo('topofpage')
           //setMediaLinkNumber(params.mediaLinkNumber)
           //props.mediaController.setTune(tune)
           //if (params.mediaLinkNumber > 0) props.mediaController.setSourceFromTune(params.mediaLinkNumber)
           
           //if (params.playState === "playMedia") {
               //props.mediaController.play()
                ////setAutoStart(false)
                ////if (Array.isArray(tune.links) && tune.links.length > 0) {
                    //////setMediaLinkNumber(0)
                    ////if (tune.links[0].startAt > 0) {
                        ////setMediaProgress(tune.links[0].startAt) 
                    ////} else {
                        ////setMediaProgress(0)
                    ////}
                    ////setMediaLoading(true); 
                    ////setShowMedia(true)
                ////}
           //} else if (params.playState === "playMidi") {
               //props.mediaController.setSrc('')
               ////props.mediaController.ytPlayerRef.current = null
               ////props.mediaController.playerRef.current = null
                 ////props.mediaController.initMidi().then(function() {
                     ////props.mediaController.setCurrentTime(0)
                     //props.mediaController.play()
                 ////})
            //}
             ////else {
                ////props.mediaController.stop()
            ////}
             ////else {
                ////setAutoStart(false)
            ////}
            
        } else {
            //props.mediaController.setTune(null)
        }
    }

    useEffect(function() {
        setupTune()
    },[sectionTuneId,props.tunes])  //, params.mediaLinkNumber, params.playState

    useEffect(function() {
        const saved = props.tunes && props.tunes[sectionTuneId]
        if (saved) setLyricsZoom(getTuneGigZoom(saved))
    }, [sectionTuneId])

    useEffect(function() {
        setupTune()
        //return function() {
            //props.mediaController.setTune(null)
        //}
    },[])

    useEffect(function() {
        setFileViewZoom(1)
    }, [tune && tune.activeFile])

    // Page-stack: scroll this section into view once the clicked tune is ready.
    // Retries allow sibling Abc panels above to finish laying out.
    useEffect(function() {
      if (!pageStackMode || !isActive || !sectionTuneId) return undefined
      if (tuneLoadState !== 'ready') return undefined
      const sectionId = tunePageSectionDomId(sectionTuneId)
      if (!sectionId) return undefined
      let cancelled = false
      function scrollToSection() {
        if (cancelled) return false
        const el = document.getElementById(sectionId)
        if (!el || typeof el.scrollIntoView !== 'function') return false
        el.scrollIntoView({ block: 'start', behavior: 'auto' })
        return true
      }
      const timers = [0, 100, 300, 600, 1000].map(function(ms) {
        return window.setTimeout(function() { scrollToSection() }, ms)
      })
      return function() {
        cancelled = true
        timers.forEach(function(id) { window.clearTimeout(id) })
      }
    }, [pageStackMode, isActive, sectionTuneId, tuneLoadState])

    function getTempo() {
        // use page tempo that has been updated from tune
        var tempo = (tune && tune.tempo > 0 ? tune.tempo :  100)
        if (tempo > 400) tempo = 400
        if (tempo < 1) tempo = 1
        return tempo
    }
    
    
       //<Button style={{float:'right'}} variant="danger" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 3a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zm0-2a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5zM3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11z"/></svg></Button>
    if (tuneLoadState === 'loading' || (tuneLoadState === 'idle' && !tune) || !props.tunesHydrated) {
        return (
          <div
            id={pageStackMode && sectionTuneId ? tunePageSectionDomId(sectionTuneId) : undefined}
            className={'music-single music-single--loading p-3'
              + (pageStackMode ? ' music-single--page-stack-item' : '')
              + (pageStackMode && isActive ? ' music-single-page-tune--active' : '')}
            role="status"
            aria-busy="true"
            aria-live="polite"
          >
            <Spinner animation="border" size="sm" className="me-2" aria-hidden="true" />
            Loading tune…
          </div>
        )
    }

    if (tuneLoadState === 'missing' || !tune) {
        return (
          <Alert variant="warning" className="m-2" role="status">
            <div>This tune could not be found. It may have been deleted or is not loaded yet.</div>
            <div className="mt-2">
              <Button as={Link} to={resolveTunesListPath({
                currentTuneBook: props.currentTuneBook,
                filter: props.filter,
                tagFilter: props.tagFilter,
                genreFilter: props.genreFilter,
                artistFilter: props.artistFilter,
                albumFilter: props.albumFilter,
                groupBy: props.groupBy,
              })} variant="primary" size="sm">Back to tune list</Button>
            </div>
          </Alert>
        )
    }

    if (tune) {
        //<iframe src={link} ></iframe>
        const previewTune = filterTuneVoices(tune, getVisibleVoiceKeys(tune.id, getTuneVoiceKeys(tune)))
        var firstVoice = previewTune.voices && Object.keys(previewTune.voices).length > 0 ? Object.values(previewTune.voices)[0] : {notes:[]}
        const hasAbcChords = props.tunebook.abcTools.hasChords(firstVoice.notes.join('\n'))
        const hasMidBlockDoubleBarlines = melodyHasMidBlockDoubleBarlines(firstVoice.notes)
        function handleNotationChordClick(abcelem) {
          if (abcelem && Array.isArray(abcelem.chord) && abcelem.chord.length > 0) {
            const name = String(abcelem.chord[0].name || '')
              .replace(/♭/g, 'b')
              .replace(/♯/g, '#')
            if (name && !isSectionMarkerChordName(name)) {
              lastNotationChordRef.current = name
            }
          }
        }
        //var parsed = props.tunebook.abcTools.parseAbcToBeats(firstVoice.notes.join("\n"))
        //var [a,b,chordsArray,c] = parsed
        var chordTranspose = chordTransposeWithCapo(tune.transpose, capoState.capoOffset, capoState.capoEnabled)
        var chords = abcjsParser.renderChords(props.tunebook.abcTools.emptyABC(tune.name)  + firstVoice.notes.join("\n"), false, chordTranspose, tune.key, tune.noteLength, tune.meter)
        var chordsWithDots = abcjsParser.renderChords(props.tunebook.abcTools.emptyABC(tune.name)  + firstVoice.notes.join("\n"), false, chordTranspose, tune.key, tune.noteLength, tune.meter)
        
        //props.tunebook.abcTools.renderChords(chordsArray,false, tune.transpose)
        var uniqueChords = buildUniqueChordsMap(chords)
        
        function getYouTubeId(url) {
            const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
        }
        
        function isYoutubeLink(urlToParse){
            if (urlToParse) {
                var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
                if (urlToParse.match(regExp)) {
                    return true;
                }
            }
            return false;
        }
        
        function shouldPlayMedia() {
            return (showMedia && Array.isArray(tune.links) && tune.links.length > mediaLinkNumber && tune.links[mediaLinkNumber])
        }
        var useMediaLinkNumber = mediaLinkNumber > 0 ? mediaLinkNumber : 0
        
        // update state to next link or navigate to next tune where there is a currentMediaPlaylist
        function nextLinkOrTune() {
            props.tunebook.navigateToNextSong(tune.id, navigate)
        }
        
        function onEnded(progress, start, stop,seek) {
            if (playalong.handlePlaybackEnded()) return
            // When this view owns the MIDI engine, finish via mediaController so intent
            // clears and the primed buffer is kept for replay (pauseAtRegionStart).
            // Host-owned MIDI ends through NowPlayingHost's onEnded instead.
            if (ownMidiEngine && props.mediaController && props.mediaController.isMidiPlaybackRoute
                && props.mediaController.isMidiPlaybackRoute()
                && props.mediaController.onEnded) {
                props.mediaController.onEnded()
                if (props.mediaPlaylist || props.abcPlaylist) {
                    nextLinkOrTune()
                }
                return
            }
            if (props.mediaPlaylist || props.abcPlaylist) {
                nextLinkOrTune()
            }
        }

        const practiceSessionActive = !!(props.practiceSession && props.practiceSession.sessionOpen)
        const mountMediaEngine = isActive && shouldMusicSingleMountMediaEngine({
            viewedTuneId: tune.id,
            queue: props.nowPlayingQueue,
            mediaController: props.mediaController,
            practiceSessionActive: practiceSessionActive,
            gigModeActive: false,
            pathname: location.pathname,
            tunes: props.tunes,
        })
        const ownMidiEngine = isActive && shouldMusicSingleOwnMidiEngine(tune.id, props.nowPlayingQueue)
                const playalongOwnsMidi = !!(playalong.isRecording || playalong.midiEngineActive)
                const notationPlaybackEngine = ownMidiEngine || playalongOwnsMidi

                const compactToolbar = windowSize[0] <= 768
                const foldControlsIntoMenu = isMusicToolbarFolded(windowSize[0], compactToolbar)
                const compactNotationControls = isMusicToolbarCompact(
                  toolbarContainerWidth,
                  windowSize[0],
                  foldControlsIntoMenu
                )
                const hasChords = tuneHasExplicitChords(tune, props.tunebook, abcjsParser)
                const availableFlags = getAvailableDisplayFlags(tune, props.tunebook, {
                  hasChords: hasChords,
                  hasInfo: hasTuneFooterMeta(tune),
                })
                const viewFlags = resolveDisplayFlagsForTune(
                  viewModeToDisplayFlags(props.viewMode),
                  tune,
                  props.tunebook,
                  { hasChords: hasChords }
                )
                const fileOverlayActive = !!findTuneFileMeta(tune, tune.activeFile)
                const activeFileMeta = fileOverlayActive
                  ? findTuneFileMeta(tune, tune.activeFile)
                  : null
                const pdfSnapshotActive = !!(activeFileMeta && isPdfTuneFileType(activeFileMeta.type))
                const toolbarClassName = 'music-buttons'
                  + (foldControlsIntoMenu ? ' music-buttons--folded-menu' : '')
                  + (compactNotationControls ? ' music-buttons--compact-controls' : '')
                  + (compactToolbar ? ' music-buttons--mobile-collapsed' : '')
                  + (pdfSnapshotActive ? ' music-buttons--pdf-snapshot' : '')
                const embedPdfToolbarInMainBar = pdfSnapshotActive
                const pdfToolbarBesideMenu = pdfSnapshotActive && foldControlsIntoMenu
                const pdfToolbarInMainRow = pdfSnapshotActive && !foldControlsIntoMenu
                const availableForControls = fileOverlayActive
                  ? Object.assign({}, availableFlags, {
                    notation: false,
                    lyrics: false,
                    structure: false,
                    chords: false,
                  })
                  : availableFlags
                const layout = resolveTuneDisplayLayout(viewFlags)
                const notationVisible = !!viewFlags.notation && viewFlags.notation !== 'off'
                const playalongNeedsNotation = !!(playalong.isRecording || playalong.compareActive)
                const lyricsVisible = !!viewFlags.lyrics
                const structureVisible = !!viewFlags.structure && hasChords
                const chordsAnnotate = !!viewFlags.chords
                // File overlay covers chart panels; keep them mounted (hidden) for capture/playback.
                const showNotationUi = (notationVisible || playalongNeedsNotation) && !fileOverlayActive
                const showLyricsUi = lyricsVisible && !fileOverlayActive
                const showStructureUi = structureVisible && !fileOverlayActive
                const viewModesEmpty = !fileOverlayActive && isViewModesEmpty(viewFlags, availableFlags)
                const fitHeightOn = !pageStackMode && notationFitMode === NOTATION_FIT_VERTICAL
                // Page stack scrolls naturally; vertical fit would clip each mate to a
                // tiny/wrong viewport slice and hide most of the staff.
                const abcFitMode = pageStackMode ? null : notationFitMode
                const syncLyricsStructure = !!layout.syncLyricsStructure
                // Without notation: fit-height scales lyrics (synced pair or lyrics-only).
                // Structure always height-fits the viewport (see StructureChordBlock).
                const lyricsStructureFitHeight = fitHeightOn && !notationVisible && !fileOverlayActive && syncLyricsStructure
                const lyricsFitHeight = fitHeightOn && !notationVisible && !fileOverlayActive && lyricsVisible && !syncLyricsStructure
                const structureOnlyView = !fileOverlayActive
                  && structureVisible
                  && !syncLyricsStructure
                  && isStructureOnlyLayout(viewFlags)
                const structureFitHeight = !fileOverlayActive && structureVisible && !syncLyricsStructure
                const structureFitHeightGrow = structureOnlyView
                const backgroundInfoText = tune && typeof tune.backgroundInfo === 'string'
                  ? tune.backgroundInfo.trim()
                  : ''
                const footerMetaRows = buildTuneFooterMetaRows(tune)
                const visibleVoiceKeys = getVisibleVoiceKeys(tune.id, getTuneVoiceKeys(tune))
                const notationTune = filterTuneVoices(tune, visibleVoiceKeys)
                const tuneTranspose = Number(tune.transpose) || 0
                // Play-along takes are one MIDI playthrough each; Abc tune.repeats
                // must not concatenate multiple passes into a single recording.
                const notationMidiRepeat = playalongOwnsMidi
                  ? 1
                  : (notationTune.repeats > 0 ? notationTune.repeats : 1)

                function handleCapoOffsetChange(offset) {
                  capoState.applyCapoOffset(offset)
                  persistTunePatch({ capo: offset })
                }

                function handleTransposeCommit(next) {
                  const nextTune = Object.assign({}, tune, { transpose: next })
                  setTune(nextTune)
                  props.tunebook.saveTune(nextTune)
                }

                const tablatureInViewMode = foldControlsIntoMenu || compactNotationControls
                const tablatureSelector = availableFlags.notation && !fileOverlayActive ? (
                  <TablatureSelector
                    tune={tune}
                    tunebook={props.tunebook}
                    variant={tablatureInViewMode ? 'menu' : 'toolbar'}
                    stopMenuClose={!!tablatureInViewMode}
                    onChange={function() {
                      setTune(Object.assign({}, tune))
                      if (props.forceRefresh) props.forceRefresh()
                    }}
                  />
                ) : null

                const transposeCapoBlock = (
                  <div className="music-transpose-capo-block">
                    <span className="music-transpose-capo-label">Transpose</span>
                    <TuneTransposeControl
                      value={tuneTranspose}
                      onCommit={handleTransposeCommit}
                    />
                    <StructureCapoControl
                      className="music-single-capo-control"
                      tune={tune}
                      chordGridText={chords}
                      capoOffset={capoState.capoOffset}
                      capoEnabled={capoState.capoEnabled}
                      onToggle={capoState.toggleCapo}
                      onOffsetChange={handleCapoOffsetChange}
                    />
                  </div>
                )

                const notationControlsBlock = fileOverlayActive ? null : (
                  <div className="music-notation-controls-block">
                    {tablatureSelector}
                    {transposeCapoBlock}
                  </div>
                )

                function persistTunePatch(patch) {
                  props.tunebook.saveTune(Object.assign({}, tune, patch))
                }

                function persistDisplayPatch(patch) {
                  if (tune && tune.id) {
                    setTuneDisplaySettings(tune.id, patch)
                  }
                  const next = Object.assign({}, tune, patch)
                  setTune(next)
                  // Keep live book overlay in sync; saveTune extracts to localStorage
                  // and strips display fields from IndexedDB / Drive ABC.
                  props.tunebook.saveTune(next, true, { skipHistory: true })
                }

                function handleNotationFitModeChange(mode) {
                  const next = setNotationFitMode(mode)
                  setNotationFitModeState(next)
                  // Keep an unchosen default view mode unsaved so later default rules still apply.
                  persistDisplayPatch(tune.viewMode
                    ? { notationFit: next, viewMode: props.viewMode }
                    : { notationFit: next })
                }

                function handleViewModeChange(val) {
                  props.setViewMode(val)
                  persistDisplayPatch({ viewMode: val })
                }

                function handleLyricsZoomChange(next) {
                  const clamped = clampGigZoom(next)
                  setLyricsZoom(clamped)
                  persistDisplayPatch({ zoom: clamped })
                }

                function handleFileViewZoomChange(next) {
                  setFileViewZoom(clampFileViewZoom(next))
                }

                pinchRouteRef.current = {
                  target: resolvePinchZoomTarget(viewFlags, {
                    fileOverlayActive: fileOverlayActive,
                    pdfSnapshotActive: pdfSnapshotActive,
                  }),
                  fitHeightOn: fitHeightOn,
                  notationFitMode: notationFitMode,
                  lyricsZoom: lyricsZoom,
                  setNotationFit: handleNotationFitModeChange,
                  persistLyricsZoom: handleLyricsZoomChange,
                }

                function fixLinks(tune,index,field,startOrEnd) {
                        var previousKey = parseInt(index - 1)
                        var link = tune.links[index]
                        if (startOrEnd === 'start' && link[field] > 0) tune.links[previousKey].startAt = link[field]
                        if (startOrEnd === 'end' && link[field] > 0) tune.links[previousKey].endAt = link[field]
                        props.tunebook.saveTune(tune)
                }

                function removeLink(tune,index) {
                        tune.links.splice(index,1)
                        props.tunebook.saveTune(tune)
                }

                function openPrintPdfLayout() {
                  const ids = pageSiblingIds && pageSiblingIds.length > 0
                    ? pageSiblingIds
                    : [tune.id]
                  navigate('/print', { state: { tuneIds: ids } })
                }

                function activateThisSection() {
                  if (!pageStackMode || isActive || !sectionTuneId) return
                  var playUrl = ''
                  if (location.pathname && location.pathname.indexOf('/playMidi') !== -1) {
                    playUrl = '/playMidi'
                  } else if (location.pathname && location.pathname.indexOf('/playMedia') !== -1) {
                    playUrl = '/playMedia'
                  }
                  navigate('/tunes/' + encodeURIComponent(String(sectionTuneId)) + playUrl)
                }

                // Capo only changes chord fingering names — notation + MIDI stay on tune.transpose.
                // TuneTransposeControl debounces onCommit so rapid +/- does not re-render Abc every step.
                const notationVisualTranspose = tuneTranspose
                const notationAbc = prepareTuneViewNotationAbc(
                  props.tunebook.abcTools.json2abc(notationTune),
                  chordsAnnotate
                )

                const menuControlsVariant = foldControlsIntoMenu ? 'menu' : 'toolbar'
                const menuControlsStopClose = foldControlsIntoMenu
                const fileControlsElement = (
                  <FileControls
                    tune={tune}
                    tunebook={props.tunebook}
                    token={props.token}
                    driveApi={driveDocs}
                    googleDocumentId={props.googleDocumentId}
                    requestGoogleScopes={props.requestGoogleScopes}
                    login={props.login}
                    variant={menuControlsVariant}
                    stopMenuClose={menuControlsStopClose}
                    onTuneChange={function(next) {
                      setTune(next)
                      props.tunebook.saveTune(next)
                      if (props.forceRefresh) props.forceRefresh()
                    }}
                  />
                )
                const zoomControlsElement = fileOverlayActive && !pdfSnapshotActive ? (
                  <FileZoomControls
                    zoom={fileViewZoom}
                    onChange={handleFileViewZoomChange}
                    tunebook={props.tunebook}
                  />
                ) : showLyricsUi && availableFlags.lyrics && !fitHeightOn ? (
                  <LyricsZoomControls
                    zoom={lyricsZoom}
                    onChange={handleLyricsZoomChange}
                  />
                ) : null
                const chordPitchButtonElement = hasAbcChords && !fileOverlayActive ? (
                  <ChordPitchButton
                    chordChart={chords}
                    structureSelector=".structure-chord-block"
                    lastNotationChordRef={lastNotationChordRef}
                    icon={props.tunebook.icons.blockchord}
                  />
                ) : null
                const playalongCanRecord = shouldShowPlayalongRecordButton(
                  tune,
                  props.tunebook,
                  fileOverlayActive
                )
                const hasPlayalongTakes = !!(playalong.takes && playalong.takes.length)
                const playalongWaiting = !!(!playalong.isRecording && playalong.isSavingTake)
                const playalongPianoRollVisible = !!(showPlayalongPianoRoll && playalong.compareActive)
                const playalongRecordButton = playalongCanRecord ? (
                  <PlayalongRecordButton
                    tunebook={props.tunebook}
                    isRecording={playalong.isRecording}
                    isWaiting={playalongWaiting}
                    takeNumber={playalong.loopTakeNumber}
                    takeMax={playalong.loopMaxTakes}
                    hasTakes={hasPlayalongTakes}
                    pianoRollVisible={playalongPianoRollVisible}
                    onOpenConfig={function() {
                      setPlayalongTempoDialogOpen(true)
                    }}
                    onTogglePianoRoll={function(nextVisible) {
                      const show = nextVisible == null
                        ? !(showPlayalongPianoRoll && playalong.compareActive)
                        : !!nextVisible
                      setShowPlayalongPianoRoll(show)
                      if (show) {
                        if (playalong.openCompare) playalong.openCompare()
                      } else if (!playalong.isRecording && playalong.closeCompare) {
                        playalong.closeCompare()
                      }
                    }}
                  />
                ) : null
                const playalongControlsElement = playalongRecordButton
                const editTuneMetaButtons = (
                  <div className="music-actions-edit-meta-row">
                    <StarToggleButton className="tune-meta-modal-btn" tunebook={props.tunebook} tune={tune} forceRefresh={props.forceRefresh} />
                    <BoostSettingsModal tunebook={props.tunebook} value={tune.boost} onChange={function(val) {tune.boost = val; props.tunebook.saveTune(tune); props.forceRefresh()}} difficulty={tune.difficulty > 0 ? tune.difficulty : 0} onChangeDifficulty={function(val) {tune.difficulty = val; props.tunebook.saveTune(tune); props.forceRefresh()}} onOpen={function() { setEditMenuShow(false) }} />
                    <BookMultiSelectorModal forceRefresh={props.forceRefresh} tunebook={props.tunebook} setBlockKeyboardShortcuts={props.setBlockKeyboardShortcuts} token={props.token} defaultOptions={props.tunebook.getTuneBookOptions} searchOptions={props.tunebook.getSearchTuneBookOptions} value={tune.books} onChange={function(val) { tune.books = val; props.tunebook.saveTune(tune);} } onOpen={function() { setEditMenuShow(false) }} />
                    <TagsSelectorModal forceRefresh={props.forceRefresh} tunebook={props.tunebook} setBlockKeyboardShortcuts={props.setBlockKeyboardShortcuts}  defaultOptions={props.tunebook.getTuneTagOptions} searchOptions={props.tunebook.getSearchTuneTagOptions} value={tune.tags} onChange={function(val) { tune.tags = val; props.tunebook.saveTune(tune);} } onOpen={function() { setEditMenuShow(false) }} />
                  </div>
                )
                const actionIconsOnly = compactToolbar
                const sharePrintDownloadDelete = (
                  <div
                    className={'music-actions-edit-actions-row' + (actionIconsOnly ? ' music-actions-edit-actions-row--icons' : '')}
                    role="group"
                    aria-label="Find similar, enhance, share, print, download, delete"
                  >
                    <span onClick={function(e) { e.stopPropagation() }}>
                      <TuneFindSimilarButton
                        tune={tune}
                        tunebook={props.tunebook}
                        tunes={props.tunes}
                        token={props.token}
                        className="tune-find-similar"
                        toggleClassName={'music-actions-menu-btn' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                        labelClassName="music-actions-menu-btn-label"
                        toggleLabel=" Find Similar"
                        hideLabel={actionIconsOnly}
                        onOpen={function() { setEditMenuShow(false) }}
                      />
                    </span>
                    <span onClick={function(e) { e.stopPropagation() }}>
                      <TuneEnhanceButton
                        tune={tune}
                        tunebook={props.tunebook}
                        token={props.token}
                        login={props.login}
                        forceRefresh={props.forceRefresh}
                        className="tune-enhance-dropdown"
                        toggleClassName={'music-actions-menu-btn' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                        labelClassName="music-actions-menu-btn-label"
                        toggleLabel=" Enhance"
                        hideLabel={actionIconsOnly}
                        onOpen={function() { setEditMenuShow(false) }}
                      />
                    </span>
                    <span onClick={function() { setEditMenuShow(false) }}>
                      <ShareTunebookModal
                        tunebook={props.tunebook}
                        token={props.token}
                        login={props.login}
                        googleDocumentId={props.googleDocumentId}
                        shareKind="tune"
                        tuneId={tune.id}
                        tuneName={tune.name}
                        tunes={props.tunes}
                        saveTune={props.tunebook.saveTune}
                        tiny={actionIconsOnly}
                        buttonClassName={'music-actions-menu-btn btn-info' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                      />
                    </span>
                    <Button
                      className={'music-actions-menu-btn btn-primary' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                      title="Print"
                      aria-label="Print"
                      onClick={function() {
                        setEditMenuShow(false)
                        openPrintPdfLayout()
                      }}
                    >
                      {props.tunebook.icons.printer}
                      {!actionIconsOnly ? <span className="music-actions-menu-btn-label"> Print</span> : null}
                    </Button>
                    <div
                      className="music-actions-nested-dropdown-wrap"
                      onClick={function(e) { e.stopPropagation() }}
                      onMouseDown={function(e) { e.stopPropagation() }}
                    >
                      <TuneDownloadDropdown
                        tunebook={props.tunebook}
                        tunes={[tune]}
                        archiveBaseName={(tune.name ? tune.name.trim() : 'tune')}
                        token={props.token}
                        user={props.user}
                        allowRestrictedFormats={true}
                        buttonVariant="success"
                        hideLabel={actionIconsOnly}
                        buttonClassName={'music-actions-menu-btn' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                        labelClassName="music-actions-menu-btn-label"
                      />
                    </div>
                    <Button
                      variant="danger"
                      className={'music-actions-menu-btn' + (actionIconsOnly ? '' : ' music-actions-menu-btn--labeled')}
                      title="Delete"
                      aria-label="Delete"
                      onClick={function() {
                        setEditMenuShow(false)
                        if (window.confirm('Do you really want to delete this tune ?')) {
                          props.tunebook.deleteTune(tune.id)
                        }
                        navigate(resolveTunesListPath({
                          currentTuneBook: props.currentTuneBook,
                          filter: props.filter,
                          tagFilter: props.tagFilter,
                          genreFilter: props.genreFilter,
                          artistFilter: props.artistFilter,
                          albumFilter: props.albumFilter,
                          groupBy: props.groupBy,
                        }))
                      }}
                    >
                      {props.tunebook.icons.bin}
                      {!actionIconsOnly ? <span className="music-actions-menu-btn-label"> Delete</span> : null}
                    </Button>
                  </div>
                )
                const linksButton = (
                  <LinksEditorModal
                    className="tune-meta-modal-btn music-actions-links-btn"
                    icon="media"
                    mediaController={props.mediaController}
                    forceRefresh={props.forceRefresh}
                    tunebook={props.tunebook}
                    tune={tune}
                    token={props.token}
                    user={props.user}
                    googleDocumentId={props.googleDocumentId}
                    login={props.login}
                    onTuneChange={function(updated) {
                      if (!updated || !updated.id) return
                      props.tunebook.saveTune(updated)
                      if (props.forceRefresh) props.forceRefresh()
                      if (tune && String(tune.id) === String(updated.id)) {
                        setTune(updated)
                      }
                    }}
                    onChange={
                      function(links, targetId) {
                        const id = targetId || (tune && tune.id)
                        if (!id) return
                        const base = (props.tunes && props.tunes[id])
                          || (tune && String(tune.id) === String(id) ? tune : null)
                        if (!base) return
                        const next = Object.assign({}, base, { id: id, links: links })
                        props.tunebook.saveTune(next)
                        if (tune && String(tune.id) === String(id)) {
                          setTune(next)
                        }
                      }
                    }
                  />
                )
                const editTuneDropdown = (
                  <Dropdown
                    as={ButtonGroup}
                    className="music-actions-edit-dropdown"
                    title="Edit tune"
                    show={editMenuShow}
                    onToggle={function(next) { setEditMenuShow(!!next) }}
                    autoClose="outside"
                  >
                    <Dropdown.Toggle variant="warning" className="music-actions-edit-btn" aria-label="Edit tune">
                      {props.tunebook.icons.pencil}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="music-actions-edit-submenu-menu"
                      popperConfig={{ strategy: 'fixed' }}
                    >
                      {getSingleViewEditModes({ mobile: isMobilePlatform() }).map(function(mode) {
                        const editorPath = editorPathForEditMode(mode.id, sectionTuneId, isMobilePlatform())
                        return (
                          <Dropdown.Item key={mode.id} as={Link} to={editorPath}>
                            {mode.label}
                          </Dropdown.Item>
                        )
                      })}
                      <Dropdown.Divider />
                      <div
                        className="music-actions-edit-meta-item"
                        role="group"
                        aria-label="Tune metadata"
                      >
                        {editTuneMetaButtons}
                      </div>
                      <Dropdown.Divider />
                      <div className="music-actions-edit-actions-item">
                        {sharePrintDownloadDelete}
                      </div>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        disabled={copyToScratchpadBusy}
                        onClick={function() { setShowScratchpadCopyPicker(true) }}
                      >
                        Copy To Scratchpad
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )
                const foldedTransposeRow = foldControlsIntoMenu && !fileOverlayActive && transposeCapoBlock ? (
                  <div className="view-mode-zoom-transpose-row">
                    {transposeCapoBlock}
                  </div>
                ) : null
                const viewModeSelector = (
                  <ViewModeSelectorModal
                    className="music-view-mode-selector"
                    viewMode={props.viewMode}
                    tune={tune}
                    tunebook={props.tunebook}
                    forceDropdown={true}
                    stopMenuClose={foldControlsIntoMenu || compactNotationControls}
                    notationFitMode={notationFitMode}
                    onNotationFitModeChange={pageStackMode ? undefined : handleNotationFitModeChange}
                    hideInlineVoiceControls={fileOverlayActive}
                    fileOverlayActive={fileOverlayActive}
                    availableOverride={availableForControls}
                    tablatureSelector={tablatureInViewMode ? tablatureSelector : null}
                    onVoiceSettingsChange={function() {
                      setVoiceSettingsVersion(function(v) { return v + 1 })
                    }}
                    fileControls={fileControlsElement}
                    afterDisplayModes={foldedTransposeRow}
                    extraMenuContent={!foldControlsIntoMenu && compactNotationControls && !fileOverlayActive
                      ? transposeCapoBlock
                      : null}
                    onChange={handleViewModeChange}
                  />
                )

                var useInstrument = localStorage.getItem('bookstorage_last_chord_instrument') ? localStorage.getItem('bookstorage_last_chord_instrument') : 'guitar'
                return <div
                  id={tunePageSectionDomId(sectionTuneId)}
                  className={
                    'music-single'
                    + (fileOverlayActive ? ' music-single--file-overlay' : '')
                    + (pageStackMode ? ' music-single--page-stack-item' : '')
                    + (pageStackMode && isActive ? ' music-single-page-tune--active' : '')
                    + (pageStackMode && !isActive ? ' music-single-page-tune--inactive' : '')
                  }
                  style={{border:'1px solid black'}}
                  {...handlers}
                  ref={setSectionRoot}
                  onClickCapture={pageStackMode && !isActive ? function() { activateThisSection() } : undefined}
                >
                        {pageStackMode ? (
                          <div className="music-single-page-tune-heading" role="status">
                            <span className="music-single-page-tune-title">{tune.name || 'Untitled'}</span>
                            {isActive ? (
                              <span className="music-single-page-tune-active-badge">Active</span>
                            ) : (
                              <button
                                type="button"
                                className="music-single-page-tune-activate-btn"
                                onClick={function(e) {
                                  e.stopPropagation()
                                  activateThisSection()
                                }}
                              >
                                Make active
                              </button>
                            )}
                          </div>
                        ) : null}
			<div ref={toolbarRef} className={toolbarClassName}>
			  <div className="music-buttons-inner">
			    <div className="music-buttons-col-left">
            {editTuneDropdown}
            {linksButton}
			    </div>

          {pdfToolbarBesideMenu ? (
            <div
              ref={setPdfToolbarHost}
              className="music-pdf-toolbar-slot music-pdf-toolbar-slot--beside-menu"
              aria-hidden={!pdfToolbarHost}
            />
          ) : null}

			    <div className="music-buttons-col-right">
            {pdfToolbarInMainRow ? (
              <div
                ref={setPdfToolbarHost}
                className="music-pdf-toolbar-slot"
                aria-hidden={!pdfToolbarHost}
              />
            ) : null}
			      {zoomControlsElement}
            {playalongControlsElement}
            {!compactToolbar ? chordPitchButtonElement : null}
            {!pdfSnapshotActive && !pageStackMode ? (
              <LyricsAutoscrollModal
                tune={tune}
                tunebook={props.tunebook}
                mediaController={props.mediaController}
                mediaLinkNumber={props.mediaController && props.mediaController.mediaLinkNumber != null ? props.mediaController.mediaLinkNumber : 0}
                musicSingleSelector=".music-single"
                barLayout="gig-inline"
                playOnly={compactToolbar}
                buttonVariant="outline-secondary"
                buttonSize="sm"
              />
            ) : null}
            {!foldControlsIntoMenu && !compactNotationControls && !fileOverlayActive ? notationControlsBlock : null}
			      {viewModeSelector}
			    </div>
			  </div>
			</div>
      {autoEnrichPending ? (
        <Alert variant="warning" className="m-2 mb-0" data-testid="auto-enrich-pending-alert">
          <div className="d-flex flex-wrap align-items-start justify-content-between gap-2">
            <div className="flex-grow-1">
              More information is loading. Please wait.
              <SearchProgressBar
                visible={true}
                percent={autoEnrichState.progress || 0}
                message={autoEnrichState.message || 'Searching...'}
                defaultMessage="Searching..."
              />
            </div>
            <Button
              size="sm"
              variant="outline-secondary"
              data-testid="auto-enrich-cancel"
              onClick={function() { cancelAddTuneAutoEnrich(sectionTuneId) }}
            >
              Cancel enhancement
            </Button>
          </div>
        </Alert>
      ) : null}
      {!autoEnrichPending && autoEnrichState.needsChordPaste ? (
        <Alert
          variant="warning"
          className="m-2 mb-0"
          data-testid="auto-enrich-chord-paste-alert"
          dismissible
          onClose={function() { dismissAddTuneAutoEnrichChordPaste(sectionTuneId) }}
        >
          <div>
            {autoEnrichState.message
              || 'Chords need a manual paste from Ultimate Guitar.'}
          </div>
          <div className="mt-2 d-flex flex-wrap gap-2">
            <Button
              size="sm"
              variant="primary"
              data-testid="auto-enrich-open-chord-paste"
              onClick={function() { setShowAutoEnrichChordPaste(true) }}
            >
              Open link and paste chords
            </Button>
            {autoEnrichState.chordPasteCandidate && autoEnrichState.chordPasteCandidate.url ? (
              <Button
                size="sm"
                variant="outline-primary"
                as="a"
                href={autoEnrichState.chordPasteCandidate.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="auto-enrich-chord-source-link"
              >
                {autoEnrichState.chordPasteCandidate.searchFallback
                  ? 'Search Ultimate Guitar'
                  : ('Open ' + (autoEnrichState.chordPasteCandidate.source || 'chord page'))}
              </Button>
            ) : null}
          </div>
        </Alert>
      ) : null}
      {!autoEnrichPending && autoEnrichState.needsNotationPaste && !autoEnrichState.needsChordPaste ? (
        <Alert
          variant="warning"
          className="m-2 mb-0"
          data-testid="auto-enrich-notation-paste-alert"
          dismissible
          onClose={handleAutoEnrichNotationAbandoned}
        >
          <div>
            {autoEnrichState.message
              || 'Notation was found on MuseScore, but needs a manual download (MusicXML, .mxl, .mscz, or MIDI) or paste.'}
          </div>
          {museScoreManualCandidates(autoEnrichState.notationManualCandidates).length > 0 ? (
            <div className="mt-2">
              <div className="small text-muted mb-1">MuseScore matches</div>
              <div className="d-flex flex-wrap gap-2">
                {museScoreManualCandidates(autoEnrichState.notationManualCandidates).slice(0, 6).map(function(item, index) {
                  const label = truncateEnrichLabel(item.title, 72) || ('Score ' + (index + 1))
                  return (
                    <Button
                      key={item.url || index}
                      size="sm"
                      variant="outline-primary"
                      as="a"
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="auto-enrich-notation-musescore-link"
                    >
                      {label}
                    </Button>
                  )
                })}
              </div>
            </div>
          ) : null}
          <div className="mt-2 d-flex flex-wrap gap-2">
            <Button
              size="sm"
              variant="primary"
              data-testid="auto-enrich-open-notation-paste"
              onClick={function() { setShowAutoEnrichNotationPaste(true) }}
            >
              Paste or import notation
            </Button>
            {autoEnrichState.notationPasteCandidate && autoEnrichState.notationPasteCandidate.url ? (
              <Button
                size="sm"
                variant="outline-primary"
                as="a"
                href={autoEnrichState.notationPasteCandidate.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="auto-enrich-notation-source-link"
              >
                {autoEnrichState.notationPasteCandidate.searchFallback
                  ? 'Search MuseScore'
                  : ('Open ' + (autoEnrichState.notationPasteCandidate.source || 'MuseScore'))}
              </Button>
            ) : null}
          </div>
        </Alert>
      ) : null}
      {!autoEnrichPending && autoEnrichState.musescorePaywalled && !autoEnrichState.needsNotationPaste ? (
        <Alert
          variant="info"
          className="m-2 mb-0"
          data-testid="auto-enrich-musescore-paywalled-alert"
          dismissible
          onClose={handleAutoEnrichNotationAbandoned}
        >
          {autoEnrichState.message
            || 'MuseScore matches require PRO or purchase; try MIDI or ABC sources instead.'}
          {tune && buildMuseScoreSearchUrl(tune.name, tune.composer) ? (
            <div className="mt-2 d-flex flex-wrap gap-2">
              <Button
                size="sm"
                variant="outline-primary"
                as="a"
                href={buildMuseScoreSearchUrl(tune.name, tune.composer)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="auto-enrich-musescore-paywalled-search"
              >
                Search MuseScore
              </Button>
              <Button
                size="sm"
                variant="primary"
                data-testid="auto-enrich-open-notation-paste"
                onClick={function() { setShowAutoEnrichNotationPaste(true) }}
              >
                Paste or import notation
              </Button>
            </div>
          ) : null}
        </Alert>
      ) : null}
      {!autoEnrichPending && autoEnrichState.failure ? (
        <Alert
          variant="danger"
          className="m-2 mb-0"
          data-testid="auto-enrich-failure-alert"
          dismissible
          onClose={function() { dismissAddTuneAutoEnrichFailure(sectionTuneId) }}
        >
          {autoEnrichState.failure}
        </Alert>
      ) : null}
      {hasMidBlockDoubleBarlines && !dismissMidBlockDoubleBarWarning ? (
        <Alert
          variant="warning"
          className="m-2 mb-0"
          data-testid="mid-block-double-barline-alert"
          dismissible
          onClose={function() { setDismissMidBlockDoubleBarWarning(true) }}
        >
          <div>
            Double barlines (<code>||</code>) appear between bars inside a section.
            That usually comes from an older chord import and breaks notation-based chord layout.
            Use single <code>|</code> mid-section and keep <code>||</code> only at section ends.
          </div>
          <div className="mt-2">
            <Button
              size="sm"
              variant="outline-primary"
              as={Link}
              to={'/editor/' + sectionTuneId + '/notationAbc'}
              data-testid="mid-block-double-barline-edit"
            >
              Edit ABC
            </Button>
          </div>
        </Alert>
      ) : null}
      <PasteChordSheetModal
        show={showAutoEnrichChordPaste}
        onHide={function() {
          setShowAutoEnrichChordPaste(false)
          dismissAddTuneAutoEnrichChordPaste(sectionTuneId)
        }}
        tune={tune || {}}
        forceAbcMerge={false}
        initialLyricSheetOnly={shouldSkipAbcMergeForChordPaste(tune)}
        externalUrl={autoEnrichState.chordPasteCandidate && autoEnrichState.chordPasteCandidate.url
          ? autoEnrichState.chordPasteCandidate.url
          : ''}
        externalLinkLabel={'Open ' + ((autoEnrichState.chordPasteCandidate && autoEnrichState.chordPasteCandidate.source) || 'Ultimate Guitar')}
        externalSourceTitle={autoEnrichState.chordPasteCandidate && autoEnrichState.chordPasteCandidate.title
          ? autoEnrichState.chordPasteCandidate.title
          : ''}
        externalHelpText={shouldSkipAbcMergeForChordPaste(tune)
          ? 'Notation is already on this tune. Open the page, copy chords and lyrics, paste below, then Import — ABC notation will be left unchanged.'
          : 'Chords were found on a site that blocks automatic import. Open the page, copy the lyrics and chords, paste them below, then Import.'}
        onSaveSections={function(result) {
          if (!result || !tune) return
          const skipAbc = !!result.skipAbcMerge || shouldSkipAbcMergeForChordPaste(tune)
          const committed = commitPasteChordSheetToTune({
            result: result,
            tune: tune,
            tunebook: props.tunebook,
            abcjsParser: abcjsParser,
            forceUpdateLyrics: true,
            skipAbcMerge: skipAbc,
            historyLabel: result.historyLabel
              || (skipAbc
                ? 'Paste chords (keep notation)'
                : 'Paste chords and lyrics'),
          })
          if (!committed || !committed.ok) return
          setTune(Object.assign({}, tune))
          if (typeof props.forceRefresh === 'function') props.forceRefresh()
          setShowAutoEnrichChordPaste(false)
          dismissAddTuneAutoEnrichChordPaste(sectionTuneId)
        }}
      />
      <ScratchpadWorkspacePickerModal
        show={showScratchpadCopyPicker}
        onHide={function() {
          if (copyToScratchpadBusy) return
          setShowScratchpadCopyPicker(false)
        }}
        title="Copy tune to scratchpad"
        description="Choose a workspace for the composition created from this tune."
        onConfirm={function(workspaceId) {
          setShowScratchpadCopyPicker(false)
          runCopyToScratchpad(workspaceId)
        }}
      />
      <LockedSourcePasteModal
        show={showAutoEnrichNotationPaste}
        onHide={function() {
          setShowAutoEnrichNotationPaste(false)
        }}
        onAbandon={handleAutoEnrichNotationAbandoned}
        candidate={autoEnrichState.notationPasteCandidate}
        searchTitle={tune && tune.name}
        searchArtist={tune && tune.composer}
        tunebook={props.tunebook}
        abcjsParser={abcjsParser}
        resolverAvailable={resolverAvailable}
        allowNotationFile={true}
        importLabel="Apply to tune"
        onImportCandidates={function(candidates) {
          const first = Array.isArray(candidates) ? candidates[0] : null
          if (!first || !first.tune || !tune || !props.tunebook || !props.tunebook.abcTools) {
            throw new Error('Could not apply pasted notation')
          }
          const imported = first.tune
          imported.id = tune.id
          // Keep lyrics already autofilled; MuseScore import should not wipe them.
          if ((!imported.words || !imported.words.length) && tune.words && tune.words.length) {
            imported.words = tune.words.slice()
          }
          if ((!imported.wLines || !imported.wLines.length) && tune.wLines && tune.wLines.length) {
            imported.wLines = tune.wLines.slice()
          }
          // Note-aligned MuseScore lyrics → plain words for the lyrics panel when empty.
          ensurePlainWordsFromNoteAlignedLyrics(imported)
          if (autoEnrichState.notationPasteCandidate && autoEnrichState.notationPasteCandidate.url) {
            imported.srcUrl = imported.srcUrl || autoEnrichState.notationPasteCandidate.url
          }
          props.tunebook.saveTune(imported, false, {
            historyLabel: 'Import MuseScore notation',
            immediate: true,
          })
          setTune(imported)
          if (typeof props.forceRefresh === 'function') props.forceRefresh()
          setShowAutoEnrichNotationPaste(false)
          dismissAddTuneAutoEnrichNotationPaste(sectionTuneId)
        }}
      />
            {(fileManager && Array.isArray(fileManager.filtered) && fileManager.filtered.length > 0 ) && <div style={{textAlign:'center'}} >
				<b style={{fontSize:'2em'}}>{tune.name}</b>
				{tune.composer && <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; by <span>{tune.composer}</span></span>} 
			</div>}
			
             {(fileManager && Array.isArray(fileManager.filtered))  && fileManager.filtered.map(function(file, fk) {
				return <FileRenderer key={fk} tunebook={props.tunebook} file={file} /> 
			 })}

             {fileOverlayActive ? (
               <TuneFilePanel
                 tune={tune} 
                 token={props.token}
                 driveApi={driveDocs}
                 tunebook={props.tunebook}
                 fitMode={NOTATION_FIT_VERTICAL}
                 zoom={fileViewZoom}
                 embedToolbarInMainBar={embedPdfToolbarInMainBar}
                 toolbarHost={pdfToolbarHost}
                 onTuneChange={function(next) {
                   setTune(next)
                   props.tunebook.saveTune(next)
                 }}
               />
             ) : null}


              
             <div className={`music-single-panels tune-display-panels ${layout.layoutClass}${!fileOverlayActive && fitHeightOn ? ' music-panels-fit-height' : ''}${fileOverlayActive ? ' music-single-panels--file-overlay' : ''}`}>
               {viewModesEmpty ? (
                 <div className="tune-view-modes-empty" role="status">
                   <div className="tune-view-modes-empty-title">
                     {tune.name}
                     {tune.composer && <span className="tune-view-modes-empty-composer"> by {tune.composer}</span>}
                   </div>
                   <div>No view modes enabled</div>
                 </div>
               ) : null}
               {/* Notation panel — always in DOM for audio continuity, visually hidden when off or file overlay */}
               <div className={`music-body-notation tune-panel-notation${!chordsAnnotate ? ' no-inline-chords' : ''}${layout.main === 'notation' ? ' tune-slot-main' : ''}${layout.side === 'notation' ? ' tune-slot-side' : ''}${(playalong.compareActive || playalong.isRecording) && showPlayalongPianoRoll ? ' tune-panel-notation--playalong-roll' : ''}`} style={showNotationUi ? {} : {display:'none'}}>
                 <div style={{paddingLeft:'0.7em', paddingRight:'0.7em'}}>
                   {(showMedia && Array.isArray(tune.links) && tune.links.length > 0) && <div style={{clear:'both', width:'100%', height:'3em'}} />}
                    <div className="playalong-notation-stack">
                    {playalongCanRecord && showPlayalongPianoRoll && (playalong.compareActive || playalong.isRecording) ? (
                      <PlayalongInlineRecordBar
                        tunebook={props.tunebook}
                        isRecording={playalong.isRecording}
                        isWaiting={playalongWaiting}
                        tune={tune}
                        compareTune={notationTune}
                        visualTranspose={notationVisualTranspose}
                        takes={playalong.takes}
                        pitchPointsById={playalong.pitchPointsById}
                        blobById={playalong.blobById}
                        trackingSettings={playalongSettings}
                        hiddenTakeIds={hiddenPlayalongTakeIds}
                        onToggleTakeHidden={togglePlayalongTakeHidden}
                        playbackSpeed={props.mediaController && props.mediaController.playbackSpeed}
                        onPauseMedia={function() {
                          if (props.mediaController && typeof props.mediaController.pause === 'function') {
                            props.mediaController.pause()
                          }
                        }}
                        onRecordClick={function() {
                          if (playalong.isRecording) {
                            playalong.stop('click')
                            setShowPlayalongPianoRoll(true)
                            return
                          }
                          setShowPlayalongPianoRoll(true)
                          if (playalong.start) playalong.start(playalongTempoBpm, playalongSettings)
                        }}
                        onTakeScored={function(recordingId, pitchPct) {
                          if (playalong.applyTakePitchPct) {
                            playalong.applyTakePitchPct(recordingId, pitchPct)
                          }
                        }}
                      />
                    ) : null}
                   <div id={"abccontainer-" + String(sectionTuneId) + "-" + (autoStart ? "Y":"N") + "-" + (localStorage.getItem('bookstorage_autoprime') === "true"?"Y":"N")}>
                     {autoStart && <Abc  showRepeats={true} warp={props.mediaController.playbackSpeed} onStarted={function() {props.mediaController.play()}} onStopped={function() {
                       // Natural MIDI end must not call pause(): that marked userPaused
                       // and used to abort/destroy the primed buffer, so replay toasted
                       // "Could not load notation playback". onEnded → pauseAtRegionStart.
                       if (props.mediaController && props.mediaController.isMidiPlaybackRoute
                           && props.mediaController.isMidiPlaybackRoute()) {
                         if (props.mediaController.setIsPlaying) props.mediaController.setIsPlaying(false)
                         return
                       }
                       if (props.mediaController && props.mediaController.pause) props.mediaController.pause()
                     }}  mediaController={props.mediaController} speakTitle={localStorage.getItem('bookstorage_announcesong')} autoStart={true} autoPrime={true} autoScroll={showNotationUi} autoScrollBlock={(playalong.isRecording || (playalong.compareActive && showPlayalongPianoRoll)) ? 'center' : 'nearest'} setMidiData={setMidiData} forceRefresh={props.forceRefresh} metronomeCountIn={true} practiceReferenceGain={(playalong.isRecording || playalong.compareActive) ? playalong.referenceGain : undefined} forceFillOff={!!(playalong.isRecording || playalong.midiEngineActive)} onPracticeBeat={playalong.isRecording ? playalong.handlePracticeBeat : undefined}  tunes={props.tunes} editableTempo={true} repeat={notationMidiRepeat} tunebook={props.tunebook}  abc={notationAbc}  meter={notationTune.meter} fitMode={abcFitMode} onEnded={onEnded} hideSvg={false} hidePlayer={true} visualTranspose={notationVisualTranspose} playbackEngine={notationPlaybackEngine} mirrorNotationPlaybackCursor={!notationPlaybackEngine} displayTuneId={tune.id} viewerElementId={(isActive || !pageStackMode) ? 'abc_music_viewer' : ('abc_music_viewer-' + String(tune.id))} tablatureSourceTune={tune} tablatureVoiceKeys={visibleVoiceKeys} onClick={handleNotationChordClick} />}
                     {!autoStart && <Abc  showRepeats={true} warp={props.mediaController.playbackSpeed} onStarted={function() {props.mediaController.play()}} onStopped={function() {
                       // Natural MIDI end must not call pause(): that marked userPaused
                       // and used to abort/destroy the primed buffer, so replay toasted
                       // "Could not load notation playback". onEnded → pauseAtRegionStart.
                       if (props.mediaController && props.mediaController.isMidiPlaybackRoute
                           && props.mediaController.isMidiPlaybackRoute()) {
                         if (props.mediaController.setIsPlaying) props.mediaController.setIsPlaying(false)
                         return
                       }
                       if (props.mediaController && props.mediaController.pause) props.mediaController.pause()
                     }}  mediaController={props.mediaController}  speakTitle={localStorage.getItem('bookstorage_announcesong')}  autoStart={false} autoPrime={true} autoScroll={showNotationUi} autoScrollBlock={(playalong.isRecording || (playalong.compareActive && showPlayalongPianoRoll)) ? 'center' : 'nearest'} setMidiData={setMidiData} forceRefresh={props.forceRefresh} metronomeCountIn={true} practiceReferenceGain={(playalong.isRecording || playalong.compareActive) ? playalong.referenceGain : undefined} forceFillOff={!!(playalong.isRecording || playalong.midiEngineActive)} onPracticeBeat={playalong.isRecording ? playalong.handlePracticeBeat : undefined}  tunes={props.tunes} editableTempo={true} repeat={notationMidiRepeat} tunebook={props.tunebook}  abc={notationAbc}  meter={notationTune.meter} fitMode={abcFitMode} onEnded={onEnded} hideSvg={false} hidePlayer={true} visualTranspose={notationVisualTranspose} playbackEngine={notationPlaybackEngine} mirrorNotationPlaybackCursor={!notationPlaybackEngine} displayTuneId={tune.id} viewerElementId={(isActive || !pageStackMode) ? 'abc_music_viewer' : ('abc_music_viewer-' + String(tune.id))} tablatureSourceTune={tune} tablatureVoiceKeys={visibleVoiceKeys} onClick={handleNotationChordClick} />}
                   </div>
                    {playalongCanRecord && showPlayalongPianoRoll && (playalong.compareActive || playalong.isRecording) ? (
                      <PlayalongStaffPitchStrips
                        tune={tune}
                        compareTune={notationTune}
                        displayAbc={notationAbc}
                        visualTranspose={notationVisualTranspose}
                        takes={playalong.takes}
                        pitchPointsById={playalong.pitchPointsById}
                        blobById={playalong.blobById}
                        trackingSettings={playalongSettings}
                        hiddenTakeIds={hiddenPlayalongTakeIds}
                        isRecording={playalong.isRecording}
                        livePitchPoints={playalong.livePitchPoints}
                        livePitchVersion={playalong.livePitchVersion}
                        getLivePitchSnapshot={playalong.getLivePitchSnapshot}
                        liveTempoBpm={playalong.liveTempoBpm}
                        liveMusicStartOffsetSeconds={playalong.liveMusicStartOffsetSeconds}
                        playbackSpeed={props.mediaController && props.mediaController.playbackSpeed}
                        showPianoRoll={showPlayalongPianoRoll}
                      />
                    ) : null}
                    </div>
                   {playalongCanRecord && showPlayalongPianoRoll && playalong.compareActive ? (
                     <PlayalongCompareOverlay
                       tune={tune}
                      compareTune={notationTune}
                       takes={playalong.takes}
                       blobById={playalong.blobById}
                       peaksById={playalong.peaksById}
                       error={playalong.error}
                       isRecording={playalong.isRecording}
                       takeNumber={playalong.loopTakeNumber}
                       takeMax={playalong.loopMaxTakes}
                       showPianoRoll={false}
                       showLineRows={false}
                       playbackSpeed={props.mediaController && props.mediaController.playbackSpeed}
                     />
                   ) : null}

                      {playalongCanRecord ? (
                      <PlayalongRecordConfigModal
                        show={playalongTempoDialogOpen}
                        onHide={function() { setPlayalongTempoDialogOpen(false) }}
                        tempoBpm={playalongTempoBpm}
                        onTempoChange={setPlayalongTempoBpm}
                        settings={playalongSettings}
                        onSettingsChange={updatePlayalongSettings}
                        canClear={!!(hasPlayalongTakes || playalong.compareActive || playalong.isRecording)}
                        onClearTakes={playalong.clearTakes}
                        onStart={function(nextSettings) {
                          setPlayalongTempoDialogOpen(false)
                          setShowPlayalongPianoRoll(true)
                          if (playalong.start) playalong.start(playalongTempoBpm, nextSettings || playalongSettings)
                        }}
                      />
                      ) : null}
                      {playalongCanRecord ? (
                      <PlayalongIncompleteTakeModal
                        show={!!playalong.incompleteTakePrompt}
                        onDiscard={function() {
                          if (playalong.discardIncompleteTake) playalong.discardIncompleteTake()
                        }}
                        onKeep={function() {
                          if (playalong.acceptIncompleteTake) playalong.acceptIncompleteTake()
                        }}
                      />
                      ) : null}
                 </div>
               </div>

               {/* Lyrics panel — keep mounted when enabled so Capture screenshot can reveal it under overlay */}
               {lyricsVisible && (
                 <div className={`music-body-lyrics tune-panel-lyrics${syncLyricsStructure ? ' tune-panel-lyrics-structure-sync' : ''}${layout.main === 'lyrics' ? ' tune-slot-main' : ''}${layout.side === 'lyrics' ? ' tune-slot-side' : ''}${layout.below === 'lyrics' ? ' tune-slot-below' : ''}${layout.wrapLyricsAroundStructure ? ' tune-lyrics-wrap' : ''}`} style={showLyricsUi ? undefined : {display:'none'}}>
                   <div className="lyrics-panel-inner">
                     {!syncLyricsStructure ? (
                       <div className="lyrics-panel-header">
                         <TitleAndLyricsEditorModal tunebook={props.tunebook} tune={tune} tunes={props.tunes} forceRefresh={props.forceRefresh} token={props.token} />
                         {tune.composer && <span className="lyrics-panel-composer"> - {tune.composer}</span>}
                       </div>
                     ) : null}
                     {syncLyricsStructure ? (
                       <LyricsStructureSyncPanel
                         tune={tune}
                         tunebook={props.tunebook}
                         chordTranspose={chordTranspose}
                         hideChords={!chordsAnnotate}
                         zoom={lyricsZoom > 0 ? lyricsZoom : 1}
                         fitHeight={lyricsStructureFitHeight}
                         chords={chords}
                         melodyNoteLines={firstVoice.notes}
                         uniqueChords={uniqueChords}
                         useInstrument={useInstrument}
                         showCapoControl={structureVisible}
                         capoOffset={capoState.capoOffset}
                         capoEnabled={capoState.capoEnabled}
                         onCapoToggle={capoState.toggleCapo}
                         onCapoOffsetChange={handleCapoOffsetChange}
                         lyricsHeader={(
                           <>
                             <TitleAndLyricsEditorModal tunebook={props.tunebook} tune={tune} tunes={props.tunes} forceRefresh={props.forceRefresh} token={props.token} />
                             {tune.composer && <span className="lyrics-panel-composer"> - {tune.composer}</span>}
                           </>
                         )}
                       />
                     ) : (
                       <div className="lyrics-zoom-host" style={{ fontSize: (lyricsZoom > 0 ? lyricsZoom : 1) + 'em' }}>
                         <TimedLyricsChordsView
                           tune={tune}
                           tunebook={props.tunebook}
                           chordTranspose={chordTranspose}
                           hideChords={!chordsAnnotate}
                           suppressLeadingTitle={true}
                           inheritZoom={true}
                           fitHeight={lyricsFitHeight}
                         />
                       </div>
                     )}
                   </div>
                 </div>
               )}

               {/* Structure (chord block) panel */}
               {structureVisible && !syncLyricsStructure && (
                 <div className={`music-body-chords tune-panel-structure${layout.main === 'structure' ? ' tune-slot-main' : ''}${layout.side === 'structure' ? ' tune-slot-side' : ''}`} style={showStructureUi ? undefined : {display:'none'}}>
                   {structureOnlyView && showStructureUi ? (
                     <div className="title music-tune-heading music-structure-only-heading">
                       {tune.name}
                       {tune.composer ? <span className="music-tune-composer"> - {tune.composer}</span> : null}
                     </div>
                   ) : null}
                   <StructureChordBlock
                     chords={chords}
                     uniqueChords={uniqueChords}
                     useInstrument={useInstrument}
                     tune={tune}
                     melodyNoteLines={firstVoice.notes}
                     chordTranspose={chordTranspose}
                     fitHeight={structureFitHeight}
                     fitHeightGrow={structureFitHeightGrow}
                     showCapoControl={true}
                     capoOffset={capoState.capoOffset}
                     capoEnabled={capoState.capoEnabled}
                     onCapoToggle={capoState.toggleCapo}
                     onCapoOffsetChange={handleCapoOffsetChange}
                   />
                 </div>
               )}
             </div>
             
             
             
             {mountMediaEngine && (
               <MediaPlayerMedia mediaController={props.mediaController} tunebook={props.tunebook} tune={tune} token={props.token} user={props.user} googleDocumentId={props.googleDocumentId} login={props.login} onEnded={onEnded} />
             )}

             {viewFlags.info && (footerMetaRows.length > 0 || backgroundInfoText) ? (
              <div className="music-single-footer-meta">
                <div className="music-tune-info-section">
                  {footerMetaRows.length > 0 ? (
                    <dl className="tune-abc-meta-footer">
                      {footerMetaRows.map(function(row) {
                        return (
                          <div key={row.key} className="tune-abc-meta-footer-row">
                            <dt>{row.label}</dt>
                            <dd>{row.value}</dd>
                          </div>
                        )
                      })}
                    </dl>
                  ) : null}
                  {backgroundInfoText ? (
                    <div className="tune-background-info-view">
                      <MarkdownContent text={backgroundInfoText} />
                    </div>
                  ) : null}
                </div>
              </div>
             ) : null}
             
             <div style={{display:'none'}} id={isActive ? 'transpose_render' : ('transpose_render-' + String(sectionTuneId))}></div>
        </div>
    }
}

export default function MusicSingle(props) {
  const params = useParams()
  const urlTuneId = params.tuneId
  const siblingIds = (props.tunebook && typeof props.tunebook.getSearchListPageSiblingIds === 'function' && urlTuneId)
    ? props.tunebook.getSearchListPageSiblingIds(urlTuneId)
    : (urlTuneId ? [urlTuneId] : [])
  const pageStack = Array.isArray(siblingIds) && siblingIds.length > 1

  // Solo single-view: land at top of the page (list used to do this on click).
  useEffect(function() {
    if (pageStack || !urlTuneId) return undefined
    const timer = window.setTimeout(function() {
      if (props.tunebook && props.tunebook.utils && typeof props.tunebook.utils.scrollTo === 'function') {
        props.tunebook.utils.scrollTo('topofpage', 10)
      } else if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0)
      }
    }, 50)
    return function() {
      window.clearTimeout(timer)
    }
  }, [pageStack, urlTuneId])

  if (!pageStack) {
    return (
      <MusicSingleSection
        {...props}
        sectionTuneId={urlTuneId}
        isActive={true}
        pageStackMode={false}
        pageSiblingIds={null}
      />
    )
  }

  return (
    <div className="music-single-page-stack">
      {siblingIds.map(function(id) {
        return (
          <MusicSingleSection
            key={String(id)}
            {...props}
            sectionTuneId={id}
            isActive={String(id) === String(urlTuneId)}
            pageStackMode={true}
            pageSiblingIds={siblingIds}
          />
        )
      })}
    </div>
  )
}

//<ImagesManagerModal tunebook={props.tunebook} tune={tune} login={props.login} logout={props.logout} token={props.token}  fileManager={fileManager} />
						
						//<RecordingsManagerModal tunebook={props.tunebook} tune={tune} login={props.login} logout={props.logout} token={props.token}  fileManager={recordingsManager} />
						
 //{(!props.abcPlaylist && props.mediaPlaylist && props.mediaPlaylist.tunes && props.mediaPlaylist.tunes.length > 0) && <div style={{position:'fixed', top: '6px', right: '6px', zIndex:999}} >
                    //<ButtonGroup variant="danger">
                        //{(!mediaLoading && showMedia && isPlaying) && <Button variant="warning" onClick={function() {
                                //try {
                                    //if (audioPlayer && audioPlayer.current) audioPlayer.current.pause()
                                    //if (ytMediaPlayer) ytMediaPlayer.pauseVideo()
                                //} catch (e) {
                                //}
                                //try {
                                    //setIsPlaying(false)
                                //} catch (e) {
                                //}
                            //}} >{props.tunebook.icons.pause}</Button>}
                        //{(!mediaLoading && showMedia && !isPlaying) && <Button variant="success" onClick={function() {
                                //try {
                                    //if (audioPlayer && audioPlayer.current) audioPlayer.current.play()
                                    //if (ytMediaPlayer) ytMediaPlayer.playVideo()
                                //} catch (e) {
                                //}
                                //try {
                                    //setIsPlaying(true)
                                //} catch (e) {
                                //}
                            //}} >{props.tunebook.icons.play}</Button>}
                        //<Button variant="danger" size="xl"  onClick={function() {props.setMediaPlaylist(null); setShowMedia(false)}} >{mediaLoading ? props.tunebook.icons.waiting : props.tunebook.icons.stop} </Button>
                        
                    //</ButtonGroup>
               //</div>}
              //{(showMedia && Array.isArray(tune.links) && tune.links.length > useMediaLinkNumber && tune.links[useMediaLinkNumber]) && <div style={{  clear:'both',  width:'100%'}} key={tune.id+"-"+params.playState+"-"+useMediaLinkNumber} >
                        //{!isYoutubeLink(tune.links[useMediaLinkNumber].link) ? <audio  ref={audioPlayer} 
                            //onCanPlay={function(event) { 
                                //setMediaLoading(false);
                                //var toSpeak = tune.name
                                //if (tune.composer) toSpeak += " by " + tune.composer
                                //var speakTitle = localStorage.getItem('bookstorage_announcesong') === "true" ? true : false
                                //if (speakTitle && !hasSpoken) window.speak(toSpeak)
                                //setHasSpoken(true)
                                //setIsPlaying(true)
                                
                                
                            //}} 
                            //width="1px" height="1px" autoPlay={"true"} 
                            //onEnded={function() {
                                //// next link
                                //if (props.mediaPlaylist || props.abcPlaylist) {
                                    //nextLinkOrTune()
                                //}
                            //}}
                            //onError={function(e) {
                                //if (props.mediaPlaylist || props.abcPlaylist) {
                                    //nextLinkOrTune()
                                //}
                            //}} 
                            //onTimeUpdate={function(e) {
                                //setMediaProgress(e.target.currentTime/e.target.duration)
                            //}}
                             //>
                                //<source src={tune.links[useMediaLinkNumber].link} type="video/ogg" />
                                //Your browser does not support the video tag.
                                //</audio> : <div style={{clear:'both'}} >
                                
                                //<YouTube videoId={getYouTubeId(tune.links[useMediaLinkNumber].link)} opts={{
                                  //width: '100%',
                                  //playerVars: {
                                    //loop : 1,
                                    //autoplay: 1,
                                    //controls: 0,
                                    //start: (tune.links[useMediaLinkNumber].startAt ? parseInt(tune.links[useMediaLinkNumber].startAt) : 0),
                                    //end: (tune.links[useMediaLinkNumber].endAt ? parseInt(tune.links[useMediaLinkNumber].endAt) : 0)
                                  //},
                                //}} 
                                //onEnd={function() {
                                    //clearInterval(youtubeProgressInterval.current)
                                    //youtubeProgressInterval.current = null
                                    //if (props.mediaPlaylist || props.abcPlaylist) {
                                        //nextLinkOrTune()
                                    //}
                                //}} 
                                //onError={function(e) {
                                    //clearInterval(youtubeProgressInterval.current)
                                    //youtubeProgressInterval.current = null
                                    //if (props.mediaPlaylist || props.abcPlaylist) {
                                        //nextLinkOrTune()
                                    //}
                                //}} 
                                //onReady={
                                    //function(event) {
                                        //setYTMediaPlayer(event.target); 
                                        //var toSpeak = tune.name
                                        //if (tune.composer) toSpeak += " by " + tune.composer
                                        //var speakTitle = localStorage.getItem('bookstorage_announcesong') === "true" ? true : false
            
                                        //if (speakTitle && !hasSpoken) window.speak(toSpeak)
                                        //setHasSpoken(true)
                                        //event.target.playVideo()
                                        //setIsPlaying(true)
                                        
                                    //}    
                                //}
                                //onStateChange={
                                    //function(e) {
                                        //if (e.data === 1) {
                                            //setMediaLoading(false)
                                            //clearInterval(youtubeProgressInterval.current)
                                            //youtubeProgressInterval.current = setInterval(function() {
                                                //setMediaProgress(e.target.getCurrentTime()/e.target.getDuration())
                                            //}, 100)
                                        //}
                                    //}
                                //} 
                                
                                 ///> 
                                
                            //</div>
                            
                        //}
                        
                   //</div>}
//{(showMedia && Array.isArray(tune.links) && tune.links.length > useMediaLinkNumber && tune.links[useMediaLinkNumber]) && <div style={{  clear:'both',  width:'100%'}} key={tune.id+"--"+params.playState+"-"+useMediaLinkNumber} >
                        
                        
                        //<div style={{float: 'left', fontSize:'0.6em', position:'relative', top:'1.5em'}} >
                            //{(audioPlayer && audioPlayer.current && audioPlayer.current.currentTime && audioPlayer.current.duration) ? <b>{audioPlayer.current.currentTime.toFixed(2)}/{audioPlayer.current.duration.toFixed(2)}</b> : null}
                            
                            //{(mediaProgress && ytMediaPlayer && ytMediaPlayer.getDuration && ytMediaPlayer.getDuration()  && ytMediaPlayer.seekTo) ? <b>{(mediaProgress * ytMediaPlayer.getDuration()).toFixed(2)}/{ytMediaPlayer.getDuration().toFixed(2)}</b> : null}
                        //</div>
                        
                        //<input style={{width:'100%',height:'40px', zIndex:9999999, marginTop:'1em'}} className="mediaprogressslider" type="range" min='0' max='1' step='0.0001' value={mediaProgress} onChange={function(e) {
                                        //setMediaProgress(e.target.value); 
                                            
                                        //try {
                                            //if (ytMediaPlayer && ytMediaPlayer.getDuration && ytMediaPlayer.seekTo) {
                                                //ytMediaPlayer.seekTo(parseFloat(e.target.value * ytMediaPlayer.getDuration()).toFixed(2)) 
                                            //};
                                        //} catch (e) {
                                        //}
                                        //if (audioPlayer && audioPlayer.current) {
                                            //audioPlayer.current.currentTime = parseFloat(e.target.value * audioPlayer.current.duration ).toFixed(2)
                                        //}
                                    
                                    //}}  />
                    //</div>}
//<Badge>{props.mediaPlaylist && props.mediaPlaylist.currentTune > 0 ? parseInt(props.mediaPlaylist.currentTune) + 1 : 1}/{props.mediaPlaylist.tunes.length}</Badge>
 //<Button title="Print" className='btn-primary'  style={{float:'left'}} onClick={window.print} >{props.tunebook.icons.printer}</Button>
                //<Button title="Download" className='btn-success' style={{float:'left'}} onClick={function() {props.tunebook.utils.download((tune.name ? tune.name.trim() : 'tune') + '.abc',props.tunebook.abcTools.json2abc(tune).trim())}} >{props.tunebook.icons.save}</Button>
                //<a  style={{float:'left'}}  target="_new" href={"https://www.youtube.com/results?search_query="+tune.name + ' '+(tune.composer ? tune.composer : '')} ><Button title="Search YouTube">{props.tunebook.icons.youtube}</Button></a>

//<Abc  autoPrime={localStorage.getItem('bookstorage_autoprime')} showTempoSlider={true} editableTempo={true} forceRefresh={props.forceRefresh} metronomeCountIn={true}  tunes={props.tunes} repeat={tune.repeats > 0 ? tune.repeats : 1 } tunebook={props.tunebook}  abc={props.tunebook.abcTools.json2abc(tune)} tempo={getTempo()} meter={tune.meter}  onEnded={onEnded} />
             



            //{props.viewMode === 'music' && <>
             
             
             //<div className="lyrics" style={{marginLeft:'2em'}} >
                //{Object.keys(words).map(function(key) {
                    //return <div  key={key} className="lyrics-block" style={{paddingTop:'1em',paddingBottom:'1em', pageBreakInside:'avoid'}} >{words[key].map(function(line,lk) {
                            //return <div key={lk} className="lyrics-line" >{line}</div>
                        //})}</div>
                //})}
             //</div>
             //</>}

 //{(window.location.href.startsWith('http://localhost') || (props.user && props.user.email &&  props.user.email === 'syntithenai@gmail.com')) &&  <div> {props.tunebook.hasLinks(tune) ? <div>
            //<div style={{clear:'both'}} ><br/><br/>    </div>
            //{tune.links.map(function(link,lk) {
                //return <div>{lk}&nbsp; 
                    //{true ? <>
                        //S:{link.startAt} {(parseInt(lk) > 0 && parseFloat(link.startAt) > 0) ? <><Button onClick={function() {fixLinks(tune,lk,'startAt','start')}}>Start</Button><Button onClick={function() {fixLinks(tune,lk,'startAt','end')}}>End</Button></> : ''} 
                        //E:{link.endAt} {(parseInt(lk) > 0 && parseFloat(link.endAt) > 0) ? <><Button onClick={function() {fixLinks(tune,lk,'endAt','start')}}>Start</Button><Button onClick={function() {fixLinks(tune,lk,'endAt','end')}}>End</Button></>:''}
                        //L:{link.link} {(parseInt(lk) > 0 && link.link.trim().length > 0) ? <><Button onClick={function() {fixLinks(tune,lk,'link','start')}}>Start</Button><Button onClick={function() {fixLinks(tune,lk,'link','end')}}>End</Button></> : ''}
                        //<Button variant="danger" onClick={function() {removeLink(tune,lk)}}>X</Button>
                    //</> : ''}
                    
                //</div>
            //})}
            
            //</div> : ''}
           //</div>}
